import * as Sentry from '@sentry/browser-bridge';

import {
  addBreadcrumb,
  addEventProcessor,
  addGlobalEventProcessor,
  addIntegration,
  captureConsoleIntegration,
  captureEvent,
  captureException,
  captureMessage,
  captureSession,
  close,
  configureScope,
  contextLinesIntegration,
  continueTrace,
  createTransport,
  debugIntegration,
  dedupeIntegration,
  defaultStackParser,
  endSession,
  extraErrorDataIntegration,
  extractTraceparentData,
  flush,
  functionToStringIntegration,
  getActiveSpan,
  getActiveTransaction,
  getClient,
  getCurrentHub,
  getCurrentScope,
  getDefaultIntegrations,
  getHubFromCarrier,
  getSpanStatusFromHttpCode,
  httpClientIntegration,
  inboundFiltersIntegration,
  init,
  isInitialized,
  lastEventId,
  linkedErrorsIntegration,
  makeMain,
  parameterize,
  reportingObserverIntegration,
  rewriteFramesIntegration,
  sessionTimingIntegration,
  setContext,
  setCurrentClient,
  setExtra,
  setExtras,
  setHttpStatus,
  setMeasurement,
  setTag,
  setTags,
  setUser,
  spanStatusfromHttpCode,
  startInactiveSpan,
  startSession,
  startSpan,
  startSpanManual,
  startTransaction,
  trace,
  withActiveSpan,
  withIsolationScope,
  withScope,
} from 'js/lib/SentryProxyMethods';
import user from 'js/lib/user';

if (user.get().authenticated) {
  Sentry?.setUser({
    id: user.get().external_id,
    isSuperuser: user.isSuperuser(),
  });
}

export * from '@sentry/browser-bridge';
export {
  addBreadcrumb,
  addEventProcessor,
  addGlobalEventProcessor,
  addIntegration,
  captureConsoleIntegration,
  captureEvent,
  captureException,
  captureMessage,
  captureSession,
  close,
  configureScope,
  contextLinesIntegration,
  continueTrace,
  createTransport,
  debugIntegration,
  dedupeIntegration,
  defaultStackParser,
  endSession,
  extraErrorDataIntegration,
  extractTraceparentData,
  flush,
  functionToStringIntegration,
  getActiveSpan,
  getActiveTransaction,
  getClient,
  getCurrentHub,
  getCurrentScope,
  getDefaultIntegrations,
  getHubFromCarrier,
  getSpanStatusFromHttpCode,
  httpClientIntegration,
  inboundFiltersIntegration,
  init,
  isInitialized,
  lastEventId,
  linkedErrorsIntegration,
  makeMain,
  parameterize,
  reportingObserverIntegration,
  rewriteFramesIntegration,
  sessionTimingIntegration,
  setContext,
  setCurrentClient,
  setExtra,
  setExtras,
  setHttpStatus,
  setMeasurement,
  setTag,
  setTags,
  setUser,
  spanStatusfromHttpCode,
  startInactiveSpan,
  startSession,
  startSpan,
  startSpanManual,
  startTransaction,
  trace,
  withActiveSpan,
  withIsolationScope,
  withScope,
};
